import styled from 'styled-components'

import ContentBox from 'components/ContentBox'

export const Container = styled(ContentBox)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 10px;
`

export const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
`

export const MfaLogo = styled.img`
  max-width: 70%;
  height: auto;
  border-radius: ${({theme}) => theme.sizes.radii.default};

  ${({theme}) => theme.breakpoints.down('laptop')} {
    max-width: 40%;
  }

  ${({theme}) => theme.breakpoints.down('tabletS')} {
    max-width: 70%;
  }
`

export const TextBold = styled.span`
  color: ${({theme}) => theme.colors.textThird};
`

export const Text = styled.div`
  font-size: ${({theme}) => theme.fontSizes.small};
  margin: auto;

  ${({theme}) => theme.breakpoints.down('laptop')} {
    font-size: ${({theme}) => theme.fontSizes.medium};
  }

  ${({theme}) => theme.breakpoints.down('tabletS')} {
    font-size: ${({theme}) => theme.fontSizes.small};
  }
`
